/*
 * @Description: 
 * @Date: 2025-09-08 17:05:00
 * @LastEditTime: 2026-10-26 13:26:01
 * @FilePath: \hui_ai_ui\src\api\index.js
 */
// src/api/index.js
import axios from 'axios';
import { Message } from 'element-ui';
import { getApiBaseUrl, modelManagementApi, modelLawApi, isTauri, isDesktop } from '@/config';
import store from '@/store';
import router from '@/router';
import './tauri'; // 确保 Tauri HTTP 适配器自动初始化（hook axios.create）
// 用于跟踪当前显示的错误消息，避免重复显示
let currentErrorMessage = null;
// 登录跳转防抖锁：多个 401 接口并行返回时只触发一次导航，避免 Navigation cancelled
let isRedirectingToLogin = false;
// 统一的登录页跳转（Sidebar.vue 同款模式：currentRoute 检查 + .catch 过滤）
const navigateToLogin = () => {
    if (router.currentRoute && router.currentRoute.path === '/ai/login') return;
    if (isRedirectingToLogin) return;
    isRedirectingToLogin = true;
    router.replace('/ai/login').catch(err => {
        if (err && err.name !== 'NavigationDuplicated' && !err.message.includes('Navigation cancelled')) {
            console.log('登录页跳转失败:', err);
        }
        isRedirectingToLogin = false;
    });
    // 导航完成后重置防抖锁（最多 3 秒兜底，避免异常情况下永远锁住）
    setTimeout(() => { isRedirectingToLogin = false; }, 3000);
};
// --- 创建一个只拆开 Axios 包装的响应处理函数 ---
const handleResponse = (response) => {
    // 我们只返回 response.data，也就是后端给我们的完整JSON对象
    // 例如：{ code: 200, message: "success", data: { items: [...] } }
    // 这样，组件中就可以继续使用 response.data.items 的方式来获取数据
    return response.data;
};
const handleError = (error) => {
    console.error('API请求出错:', error);
    // 有message字段就使用message字段，否则保持原样
    let errorMessage = error.message;
    if (error.response && error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message;
    }
    
    // 处理 401 错误
    // 桌面端（Tauri / Electron，即 isDesktop）统一只弹登录弹窗，绝不跳登录页；
    // 只有 Web 端才走路由跳转
    if (error.response && error.response.data && error.response.data.code === 401) {
        if (isDesktop) {
            // 登录接口已放开 CORS，Electron / Tauri 都直接复用 Web 版登录弹窗，
            // 不需要 tauri-http 绕跨域，也不使用老的 invoke 登录框
            console.log(`当前环境:${isTauri ? 'tauri' : 'electron'}(桌面端)，弹出登录弹窗`, error.response.data);
            store.commit('SET_SHOW_LOGIN_WEB_DIALOG', true);
        } else {
            console.log("当前环境:web", error.response.data);
            // Web 环境回到主页逻辑
            const isFromOA = sessionStorage.getItem("fromOA") === "true" || (window.location.search && window.location.search.includes("loginInfo"));
            if (isFromOA) {
                navigateToLogin();
                // 返回OA主页
                // window.location.href = "https://oa.lawxp.com/";
            } else {
                sessionStorage.removeItem('userId');
                sessionStorage.removeItem('pctoken');
                sessionStorage.removeItem('loginInfoFromUrl');
                sessionStorage.removeItem('fromOA');
                try { localStorage.removeItem('userId'); localStorage.removeItem('pctoken'); localStorage.removeItem('loginInfoFromUrl'); localStorage.removeItem('fromOA'); localStorage.removeItem('_authCachedAt'); } catch (e) {}
                navigateToLogin();
                // // 使用 process.env.VUE_APP_ENV 来判断环境
                // const appEnv = process.env.VUE_APP_ENV;
                // console.log("当前环境:", appEnv);
                // if (appEnv !== "production") {
                //     setTimeout(() => {
                //         window.location.href = "https://csapi1.xinfushenghuo.cn/ex.pc/#/Index";
                //     }, 3000);
                // } else {
                //     setTimeout(() => {
                //         window.location.href = "https://xinfushenghuo.cn/";
                //     }, 3000);
                // }
            }
        }
    }
    
    // 添加去重逻辑，避免重复显示相同的错误消息
    if (!currentErrorMessage || currentErrorMessage !== errorMessage) {
        currentErrorMessage = errorMessage;
        Message({
            message: errorMessage,
            type: 'error',
            duration: 5 * 1000,
            showClose: true,
            onClose: () => {
                // 提示关闭后清除状态，允许后续显示新的错误提示
                currentErrorMessage = null;
            }
        });
    }
    return Promise.reject(error);
};

// --- 创建两个Service实例，并应用这个简单的拦截器 ---
// 1. 【动态域名】的 Axios 实例
export const dynamicService = axios.create({
    timeout: 15 * 60000
});
dynamicService.interceptors.request.use(
    config => {
        config.baseURL = getApiBaseUrl();
        // 添加Authorization header
        const pctoken = sessionStorage.getItem('pctoken');
        if (pctoken) {
            config.headers['Authorization'] = `Bearer ${pctoken}`;
            const fromOA = sessionStorage.getItem('fromOA');
            config.headers['Client-channel'] = fromOA === 'true' ? 'oa' : (isDesktop ? 'pc' : 'web');
        }
        return config;
    },
    handleError
);
dynamicService.interceptors.response.use(handleResponse, handleError);

// 2. 【getUserId固定域名】的 Axios 实例
export const staticService = axios.create({
    baseURL: modelManagementApi,
    timeout: 60000
});
staticService.interceptors.response.use(handleResponse, handleError);
// 汇法law知识点 - 修改为使用相对路径，通过代理解决跨域问题
export const lawService = axios.create({
    // 移除固定的baseURL，使用相对路径
    baseURL: modelLawApi,
    timeout: 60000
});

// 添加请求拦截器，确保使用相对路径通过代理
lawService.interceptors.request.use(
    config => {
        // 确保使用相对路径，让请求通过vue.config.js中的代理配置
        // 代理会将/lawxpapi开头的请求转发到目标服务器
        return config;
    },
    handleError
);
lawService.interceptors.response.use(handleResponse, handleError);

// 默认导出
export default dynamicService;